import AuthLayout from "@/layouts/auth-layout";
import "./styles.scss";
import { Button, Icon } from "@/components";
import SignInForm from "./form";
import { useNavigate } from "react-router-dom";
// import { useAuth } from "@/contexts/auth-context";
// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

export const SignIn = () => {
  const navigate = useNavigate();
  return (
    <AuthLayout>
      <div className="signin">
        <Button variant="neutral" className="go-back">
          <Icon name="left_arrow" />
          Back
        </Button>

        <div className="headings">
          <h1>Sign In</h1>
          <h3>
            To sign in, please type in the email address & password linked to
            your Pluritongues account.
          </h3>
        </div>

        <SignInForm />
        <h6>
          If you aren’t registered on Pluritongues, download the app{" "}
          <a
            href="https://www.pluritongues.com/get-app"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          {" or "}
          <button
            className="register-button"
            onClick={() => navigate("/register")}
          >
            sign up,
          </button>{" "}
          it only take few steps.
        </h6>
      </div>
    </AuthLayout>
  );
};
